import * as moment from 'moment';

interface CustomerInfo {
  name: string;
  email?: string;
  patient_id: string;
  cpfCnpj?: string;
  postalCode?: string;
  addressNumber?: string;
  addressComplement?: string;
  city?: string;
  state?: string;
  phone?: string;
  birthDate?: string;
}

interface CreditCard {
  holderName: string;
  number: string;
  expiryYear: string;
  expiryMonth: string;
  ccv: string;
}

interface CardInfo {
  token: string;
  payment_method_id: string;
  issuer_id: string;
  installments: number;
  payer: {
    email: string;
    identification: {
      type: string;
      number: string;
    };
  };
}

interface Qrcode {
  code: string;
  base64: string;
  ticket_url?: string;
  expiration?: string;
}

interface PagarmeOrderItem {
  amount: number;
  code: string;
  description: string;
  quantity: number;
}

interface PagarmeCustomer {
  name: string;
  email: string;
  document: string;
  type: 'individual' | 'company';
  phone: string;
}

interface PagarmeCard {
  number: string;
  holder_name: string;
  exp_month: number;
  exp_year: number;
  cvv: string;
  billing_address?: {
    line_1: string;
    zip_code: string;
    country: string;
    state?: string;
    city?: string;
  };
}

interface PagarmePayment {
  payment_method: 'credit_card' | 'pix' | 'boleto';
  credit_card?: {
    installments: number;
    card: PagarmeCard;
  };
  pix?: {
    expires_in: number;
  };
}

export type PaymentStatus = 'NOT_PAID' | 'PAID' | 'PENDING' | 'CREATING' | 'FAILED' | 'REFUNDED' | 'CANCELED' | 'EXPIRED';
export type PaymentBillingType = 'CREDIT_CARD' | 'PIX' | 'PHYSICAL' | 'BOLETO';
export type PaymentMethodCode = 'CREDIT_CARD' | 'PIX' | 'PHYSICAL' | 'BOLETO';

export interface Payment {
  payment_id?: string;
  order_id?: string;
  charge_id?: string;
  provider?: string;
  payment_method?: PaymentMethodCode;
  expires_at?: string;
  boleto_url?: string;
  boleto_barcode?: string;
  pix_qr_code?: string;
  pix_qr_code_base64?: string;
  status_reason?: string;
  healthcareservice_name?: string;
  status?: PaymentStatus;
  billingType?: PaymentBillingType;
  due_at?: string;
  payment_at?: string;
  customer_info?: CustomerInfo;
  encounter_id?: string;
  confirmed_by?: string;
  value?: string;
  qrcode?: Qrcode;
  card_info?: CardInfo;
  credit_card?: CreditCard;
  card_token?: string;
  card_id?: string;
  installments?: number;
  confirmed_at?: string;
  confirmation_code?: string;
  code?: string;
  items?: PagarmeOrderItem[];
  customer?: PagarmeCustomer;
  payments?: PagarmePayment[];
  closed?: boolean;
  metadata?: Record<string, string>;
  force_new?: boolean;
}

export interface PaymentAPIResponse {
  payment_id?: string;
  order_id?: string;
  charge_id?: string;
  provider?: string;
  payment_method?: PaymentMethodCode;
  expires_at?: string;
  boleto_url?: string;
  boleto_barcode?: string;
  pix_qr_code?: string;
  pix_qr_code_base64?: string;
  status_reason?: string;
  healthcareservice_name?: string;
  status?: PaymentStatus;
  billingType?: PaymentBillingType;
  due_at?: string;
  payment_at?: string;
  customer_info?: CustomerInfo;
  encounter_id?: string;
  confirmed_by?: string;
  value?: string;
  credit_card?: CreditCard;
  qrcode?: Qrcode;
  card_info?: CardInfo;
  card_token?: string;
  card_id?: string;
  installments?: number;
  confirmed_at?: string;
  confirmation_code?: string;
  code?: string;
  items?: PagarmeOrderItem[];
  customer?: PagarmeCustomer;
  payments?: PagarmePayment[];
  closed?: boolean;
  metadata?: Record<string, string>;
  force_new?: boolean;
}

export interface paymentI {
  id: number | null;
  name: string;
  active: boolean;
  icon?: string;
  flags?: flagI[];
  conditions?: number[];
}

export interface flagI {
  id?: number;
  name: string;
  active?: boolean;
  icon?: string;
}

export interface paymentConditionI {
  id?: number;
  condition: number;
}

export const flagInitialState: flagI = {
  name: '',
  active: true,
  icon: '',
};

export const paymentMethodInitialState: paymentI = {
  id: null,
  name: '',
  active: true,
  icon: '',
  flags: [],
  conditions: [],
};
